import React, { useState } from 'react';
import { Tooltip, Typography, Empty } from 'antd';
import { InfoCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import CandidateApplicationsTable from '../tables/CandidateApplicationsTable';
import { formatDate } from '../../utils/dateUtils';

const { Text } = Typography;

const CandidateReferralSection = ({ referral }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const history = useHistory();

  const handleReferrerClick = (e) => {
    e.preventDefault();
    if (referral.user?.id) {
      history.push(`/employees/${referral.user.id}`);
    }
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const referrerName = `${referral.user?.firstName || ''} ${referral.user?.lastName || ''}`.trim();
  const referralDate = formatDate(referral.createdAt);
  const applicationCount = referral.applications?.length || 0;

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '12px 16px',
          backgroundColor: '#fff',
          borderRadius: isExpanded ? '16px 16px 0 0' : '16px',
          border: '1px solid #f0f0f0',
          borderBottom: isExpanded ? 'none' : '1px solid #f0f0f0',
          cursor: 'pointer'
        }}
        onClick={handleToggle}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
          <div>
            <div style={{ marginBottom: '2px' }}>
              <Text type="secondary" style={{ fontSize: '11px' }}>
                Referred by
              </Text>
            </div>
            <div style={{ marginBottom: '2px' }}>
              <Text style={{ fontWeight: '500', fontSize: '14px' }}>
                <a
                  href={`/employees/${referral.user?.id}`}
                  onClick={handleReferrerClick}
                  style={{
                    color: '#1890ff',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                  }}
                >
                  {referrerName}
                </a>
              </Text>
            </div>
            <div>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {referralDate} • {applicationCount} {applicationCount === 1 ? 'application' : 'applications'}
              </Text>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '20px' }}>
            {referral.bonusEligible && (
              <span
                style={{
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: '500',
                  backgroundColor: '#f6ffed',
                  color: '#52c41a',
                  border: '1px solid #b7eb8f'
                }}
              >
                Bonus Eligible
              </span>
            )}

            {referral.eligibilityNote && (
              <Tooltip title={referral.eligibilityNote} placement="top">
                <InfoCircleOutlined
                  style={{
                    color: '#1890ff',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>

        <div>
          {isExpanded ? (
            <UpOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />
          ) : (
            <DownOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />
          )}
        </div>
      </div>

      {isExpanded && (
        <div>
          {referral.applications && referral.applications.length > 0 ? (
            <CandidateApplicationsTable
              applications={referral.applications}
              referral={referral}
            />
          ) : (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <Text type="secondary">No applications for this referral</Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CandidateReferralSection;